var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgComment2 = function SvgComment2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 15,
    "data-width-24": 20,
    viewBox: "0 0 19.5 15.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "m1.15 14.7 1.153-3.105C1.933 10.757.7 9.639.7 7.125.7 2.935 3.782.84 5.755.7h7.89C15.741.84 18.7 2.795 18.7 7.125c0 4.693-3.493 6.053-5.301 6.146H5.015z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgComment2);
export default ForwardRef;